export type AccuracyColorTheme = 'green' | 'borage-blue' | 'not2';

export interface AccuracyLevelConfig {
  level: number;
  accuracy: number;
  speedLabel: string;
  colorTheme: AccuracyColorTheme;
}

export const MIN_ACCURACY_LEVEL = 1;
export const MAX_ACCURACY_LEVEL = 10;
export const DEFAULT_ACCURACY_LEVEL = 5;

export const ACCURACY_LEVELS: AccuracyLevelConfig[] = [
  { level: 1, accuracy: 60, speedLabel: 'AI_SEARCH.ACCURACY.SPEED_VERY_FAST', colorTheme: 'green' },
  { level: 2, accuracy: 65, speedLabel: 'AI_SEARCH.ACCURACY.SPEED_VERY_FAST', colorTheme: 'green' },
  { level: 3, accuracy: 70, speedLabel: 'AI_SEARCH.ACCURACY.SPEED_FAST', colorTheme: 'green' },
  {
    level: 4,
    accuracy: 75,
    speedLabel: 'AI_SEARCH.ACCURACY.SPEED_FAST',
    colorTheme: 'borage-blue',
  },
  {
    level: 5,
    accuracy: 80,
    speedLabel: 'AI_SEARCH.ACCURACY.SPEED_FAST',
    colorTheme: 'borage-blue',
  },
  {
    level: 6,
    accuracy: 85,
    speedLabel: 'AI_SEARCH.ACCURACY.SPEED_NORMAL',
    colorTheme: 'borage-blue',
  },
  {
    level: 7,
    accuracy: 89,
    speedLabel: 'AI_SEARCH.ACCURACY.SPEED_NORMAL',
    colorTheme: 'borage-blue',
  },
  { level: 8, accuracy: 92, speedLabel: 'AI_SEARCH.ACCURACY.SPEED_SLOW', colorTheme: 'not2' },
  { level: 9, accuracy: 95, speedLabel: 'AI_SEARCH.ACCURACY.SPEED_SLOW', colorTheme: 'not2' },
  {
    level: 10,
    accuracy: 100,
    speedLabel: 'AI_SEARCH.ACCURACY.SPEED_VERY_SLOW',
    colorTheme: 'not2',
  },
];
